function allDiscountsApp() {
  return {
    isModalOpen: false,
    allDiscounts: [],
    openModal() {
      const main_content = document.querySelector('#MainContent');
      main_content.classList.add('is-modal-opened');
      this.isModalOpen = true;
    },
    closeModal() {
      const main_content = document.querySelector('#MainContent');
      main_content.classList.remove('is-modal-opened');
      this.isModalOpen = false;
    },
    formatPercent(percent) {
      return `${percent}% OFF`;
    },
    formatPriceRange(price_range) {
      return `Orders ${price_range}`;
    },
    init() {
      document.addEventListener('showDiscounts', (e) => {
        this.allDiscounts = e.detail.allDiscounts;
        this.openModal();
      });
    },
  };
}
